import React from "react";
import { AuthenticationView } from "src/authentication/views/AuthenticationView";

export const NonAuthenticatedRoutes = () => {
  return <AuthenticationView />;
};
